import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { COUNTRY_CONFIG, LANGUAGE_CONFIG, SITE_ID } from 'Douleutaras/constants/localization';
import { useTranslation } from 'react-i18next';
import { useLocalization } from 'Douleutaras/hooks/localization';
import { URLS } from 'Douleutaras/constants/urls';

import './DefaultHeaderLogo.scss';

// truncated: icon only on phones, as in Django's compact scroll header
const DefaultHeaderLogo = ({ isPro, truncated = false }: { isPro: boolean; truncated?: boolean }) => {
  const { i18n } = useTranslation();
  const { countryCode } = useLocalization();
  const logoSrc = `${process.env.ASSETS_CDN_PATH}/douleutaras/img/vendor/v1/dashboard/logo/${SITE_ID[countryCode]}-logo.svg`;
  const logoAlt = COUNTRY_CONFIG.SITE_NAME[countryCode];
  const homeLink = LANGUAGE_CONFIG.LINKS.HOME_PAGE[i18n.language];

  return (
    <article styleName={classNames({
      'default-header-logo': true,
      'default-header-logo--truncated': isPro || truncated
    })}>
      {!isPro ? (
        <a styleName="default-header-logo__link" href={homeLink}>
          <span styleName="default-header-logo__icon" />
          <img src={logoSrc} alt={logoAlt} />
        </a>
      ) : (
        <Link styleName="default-header-logo__link" to={URLS.SELLER.MY_JOBS}>
          <span styleName="default-header-logo__icon" />
          <img src={logoSrc} alt={logoAlt} />
        </Link>
      )}
    </article>
  );
};

export default DefaultHeaderLogo;
